import client from '../client';
import * as clientContactMutations from "../mutations/clientContact";
import * as clientContactQueries from "../queries/clientContact";



export function getContacts(success, error, clientId, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        variables: { clientId: clientId },
        query: clientContactQueries.all,
    })
        .then(success)
        .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { contact: data },
        mutation: clientContactMutations.add,
    }).then(success).catch(error);;
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, contact: data },
        mutation: clientContactMutations.edit,
    }).then(success).catch(error);
}


export function remove(success, error, id) {
    client.mutate({
        variables: { id: id },
        mutation: clientContactMutations.remove,
    }).then(success).catch(error);
}




// WEBPACK FOOTER //
// ./src/graphql/actions/clientContact.js